/* 

*/

import Ciber from "pages/AcademiaCiber";

export default function AcademiaCiberPage() {
  return <Ciber />;
}
